import React, { memo } from "react";

interface TextArea {
  id?: string;
  name?: string;
  label?: string;
  defaultValue?: string;
  value?: string | number | readonly string[] | undefined;
  rows?: string;
  onChange?: (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => void | Promise<void>;
  placeholder?: string;
  error?: boolean;
  className?: string;
  isReadOnly?: boolean;
  hasError?: boolean;
  disabled?: boolean;
}

const TextAreaBase = (props: TextArea) => {
  const border = props.hasError
    ? "border-accent focus:border-accent"
    : "border-color-gray-200";
  return (
    <>
      {props.label && (
        <label className="block mb-4 text-xs">{props.label}</label>
      )}
      {props.rows ? (
        <textarea
          className={[
            !!props.error && "border-accent",
            border,
            props.className,
          ].join(" ")}
          id={props.id}
          name={props.name}
          rows={+props.rows}
          defaultValue={props.defaultValue}
          value={props.value}
          placeholder={props.placeholder}
          disabled={props.disabled}
          readOnly={props.isReadOnly}
          onChange={props.onChange}
        />
      ) : (
        <textarea
          className={[
            !!props.error && "border-accent",
            border,
            props.className,
          ].join(" ")}
          id={props.id}
          name={props.name}
          value={props.value}
          defaultValue={props.defaultValue}
          placeholder={props.placeholder}
          disabled={props.disabled}
          readOnly={props.isReadOnly}
          onChange={props.onChange}
        />
      )}
    </>
  );
};

export const TextArea = memo(TextAreaBase);
